import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import React, { useState, Fragment } from 'react';
import Link from '@mui/material/Link';
import VoteButton from './VoteButton';

const VoteDetailsBtn = props => {
  const [open, setOpen] = useState(false);

  const below8 = [];
  const below6 = [];
  const below4 = [];
  const below2 = [];
  const below0 = [];
  const below3 = [];
  const below5 = [];
  const below7 = [];
  const below9 = [];
  const above9 = [];

  const allVoteLists = [
    { list: above9, weight: 10 },
    { list: below9, weight: 8 },
    { list: below7, weight: 6 },
    { list: below5, weight: 4 },
    { list: below3, weight: 1 },
    { list: below0, weight: -1 },
    { list: below2, weight: -3 },
    { list: below4, weight: -5 },
    { list: below6, weight: -7 },
    { list: below8, weight: -9 },
  ];

  if (props.votes) {
    props.votes.forEach(vote => {
      const { value } = vote;
      if (value < -8) below8.push(vote);
      else if (value < -6) below6.push(vote);
      else if (value < -4) below4.push(vote);
      else if (value < -2) below2.push(vote);
      else if (value < 0) below0.push(vote);
      else if (value < 3) below3.push(vote);
      else if (value < 5) below5.push(vote);
      else if (value < 7) below7.push(vote);
      else if (value < 9) below9.push(vote);
      else if (value >= 9) above9.push(vote);
    });
  } else return <></>;

  const smilesButton = (
    <Typography color="textSecondary" component="span">
      <Button
        className="m-1"
        onClick={props.totalSmiles ? () => setOpen(true) : undefined}
        size="small"
        color="inherit"
      >
        {props.totalSmiles || '0'} smiles
      </Button>
    </Typography>
  );

  return (
    <>
      <div style={{ marginBottom: '-10px' }} className="d-inline">
        {props.totalSmiles ? (
          <Tooltip
            title={props.votes.map((vote, i) => {
              if (i < 11)
                return (
                  <Fragment key={vote.voter}>
                    {vote.voter} <VoteButton weight={vote.value} size="10" />
                    <br />
                  </Fragment>
                );
              return <></>;
            })}
            placement="top"
            arrow
          >
            {smilesButton}
          </Tooltip>
        ) : (
          smilesButton
        )}
        <a href="#comments">
          <Typography color="textSecondary" component="span">
            <Button className="m-1" size="small" color="inherit">
              {props.numberreplies || '0'} comments
            </Button>
          </Typography>
        </a>
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="text-center" id="form-dialog-title">
          Smiles received: {props.totalSmiles}
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              padding: '2px',
            }}
          >
            <IconButton
              onClick={() => setOpen(false)}
              aria-label="Close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          {allVoteLists.map((list, i) => {
            return (
              <Fragment key={i}>
                {list.list.length > 0 && (
                  <>
                    {i !== 0 && <Divider className="mt-2 mb-2" />}
                    <p>
                      <VoteButton weight={list.weight} size="40" />
                    </p>
                    {list.list.map(vote => {
                      return (
                        <Link key={vote.voter} href={`/@${vote.voter}`}>
                          <Tooltip
                            title={`${vote.voter} ${vote.value > 0 ? '+' : ''}${
                              vote.value
                            }`}
                            placement="top"
                            arrow
                          >
                            <div className="d-inline-block">
                              <Avatar src={`/avatar/${vote.voter}/small`} />
                            </div>
                          </Tooltip>
                        </Link>
                      );
                    })}
                  </>
                )}
              </Fragment>
            );
          })}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default VoteDetailsBtn;
